export default __webpack_public_path__ + "static/media/face-2.65c41821.svg";